import type { StudentDashboardRoutes } from 'ulanano-cms-api/routes/student-dashboard'
import { createGranularTreaty } from '../api-factory'

export const studentDashboardApi = createGranularTreaty<StudentDashboardRoutes>({ withCookies: true })
